import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
import { cssVariables } from 'theme/theme';
const { WHITE } = colors;

const layoutStyle = makeStyles(() => ({
	calContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexWrap: 'wrap'
	},
	calander: {
		minWidth: cssVariables.container.width,
		minHeight: cssVariables.container.height,
		backgroundColor: WHITE,
		height: cssVariables.container.height,
		width: cssVariables.container.width,
		margin: 5
	},
	days: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'center'
	}
}));

export default layoutStyle;
